import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  NavbarAdmin,
  Modal,
  Resizer,
} from "../../components/CustomComponent.js";
import BG from "../../assets/images/logo.png";
import Footer from "../../components/FooterAdmin.js";
export default class Tiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],

      tab: "th",

      uid: "",
      photo: "",
      th_name: "",
      th_sector: "",
      th_address: "",
      us_name: "",
      us_sector: "",
      us_address: "",
      jp_name: "",
      jp_sector: "",
      jp_address: "",
      cn_name: "",
      cn_sector: "",
      cn_address: "",
    };
  }

  async componentDidMount() {
    loading(false);
   if (!profile || profile?.ep < new Date().getTime()) {
         localStorage.removeItem("scp-profile");
         alert(
           "/login",
           "warning",
           "แจ้งเตือน",
           "Token หมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง"
         );
       }else{
         await this.Get();
       }
  }
  Get = async () => {
    loading(true);
    let response = await fetch(
      process.env.REACT_APP_API_URL + `/customer.json`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    this.setState({ data: result ? Object.values(result) : [] });

    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, photo, th_name,
th_sector,
th_address,
us_name,
us_sector,
us_address,
jp_name,
jp_sector,
jp_address,
cn_name,
cn_sector,
cn_address } = this.state;
    loading(true);
    let now = new Date().getTime();
    await fetch(
      process.env.REACT_APP_API_URL +
        `/customer/${uid || now}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: uid || now,
          photo,
          th_name: th_name.trim(),
      th_sector: th_sector.trim(),
      th_address: th_address.trim(),
      us_name: us_name.trim(),
      us_sector: us_sector.trim(),
      us_address: us_address.trim(),
      jp_name: jp_name.trim(),
      jp_sector: jp_sector.trim(),
      jp_address: jp_address.trim(),
      cn_name: cn_name.trim(),
      cn_sector: cn_sector.trim(),
      cn_address: cn_address.trim(),
        }),
      }
    );
    await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ last_update: new Date().getTime() }),
    });
    alert("#", "success");
    loading(false);
  };
  Delete = async (uid) => {
    if (
      await alert(
        "",
        "warning",
        "ลบข้อมูล",
        "ยืนยันการลบข้อมูลนี้หรือไม่?",
        "ลบข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      await fetch(process.env.REACT_APP_API_URL + `/customer/${uid}.json`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      await fetch(process.env.REACT_APP_API_URL + `/updated.json`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ last_update: new Date().getTime() }),
      });
      alert("#", "success");
      loading(false);
    }
  };

  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      data,tab,

      photo,
      th_name,
th_sector,
th_address,
us_name,
us_sector,
us_address,
jp_name,
jp_sector,
jp_address,
cn_name,
cn_sector,
cn_address,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <NavbarAdmin />
        <div className="body p-3 mt-3">
          <h4 className="fw-bold mb-4">ลูกค้า</h4>
          <div className="rounded-3 bg-white p-3 mb-3">
            <h5 className="fw-bold mb-3">
              <span className="icon me-1 text-14">{"\uf0b0"}</span>ฟิลเตอร์
            </h5>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="Search..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-warning px-3 me-2 mb-2"
                  onClick={() => {}}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({ filter_search: "" });
                  }}
                >
                  ล้างข้อมูล
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-dark px-4"
              onClick={() => {
                this.setState({
                  modal_create: true,
                  tab: "th",
                  photo: "",
                  name: "",
      sector: "",
      address: "",
      us_name: "",
      us_sector: "",
      us_address: "",
      jp_name: "",
      jp_sector: "",
      jp_address: "",
      cn_name: "",
      cn_sector: "",
      cn_address: "",
                });
              }}
            >
              สร้างลูกค้า
            </button>
          </div>
          <div className="rounded-3 bg-white p-3">
            <div className="table-responsive">
              <table className="table table-hover table-striped-columns">
                <thead>
                  <tr>
                    <td className="wpx-70 text-center">รูปภาพ</td>
                    <td>ชื่อลูกค้า</td>
                    <td>ภาค</td>
                    <td>ข้อความ</td>
                    <td className="wpx-80 text-center">จัดการ</td>
                  </tr>
                </thead>
                <tbody>
                  {data
                    ?.filter(
                      (item) =>
                        !filter_search ||
                        (item.name + item.address).includes(filter_search)
                    )
                    .map((item, index) => (
                      <tr key={`array-${index}`}>
                        <td className="text-center">
                          <img
                            alt="example"
                            src={
                              item.photo || BG
                            }
                            className="rounded-3 hpx-30 wpx-30 bg-primary-light"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </td>
                        <td>{item.th_name}</td>
                        <td>{item.th_sector}</td>
                        <td>{item.th_address}</td>
                        <td>
                          <div className="w-100 d-flex justify-content-center">
                            <BtnIcon
                              type="update"
                              onClick={() => {
                                this.setState({ modal_update: true, ...item });
                              }}
                            />
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
<div className="hpx-40"></div>
                <Footer />
        </div>
        {/* CREATE UPDATE */}
        <Modal
          show={modal_create || modal_update}
          onHide={() =>
            this.setState({ modal_create: false, modal_update: false })
          }
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">
              {modal_create ? "สร้าง" : modal_update ? "แก้ไข" : ""}ลูกค้า
            </h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
             <div className="d-flex mb-3">
            <div
              className="border-primary rounded-4 d-flex"
              style={{ padding: 2 }}
            >
              <button
                className={`btn btn-${tab === "th" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "th" });
                }}
              >
                ไทย
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "us" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "us" });
                }}
              >
                อังกฤษ
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "jp" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "jp" });
                }}
              >
                ญี่ปุ่น
              </button>
              <div style={{ width: 3 }}></div>
              <button
                className={`btn btn-${tab === "cn" ? "primary" : "link text-dark"} text-decoration-none px-3`}
                onClick={() => { this.setState({ tab: "cn" });
                }}
              >
                จีน
              </button>
            </div>
          </div>
            <div className="d-flex mb-2">
              <div className="wpx-100 mt-2">รูปภาพ{required}</div>
              <div className="d-flex flex-wrap">
                <input
                  hidden
                  accept="image/*"
                  id="image"
                  type="file"
                  onChange={async (e) => {
                    loading(true);
                    const file = e.target.files[0];
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onloadend = async () => {
                      const base64 = reader.result;
                      console.log(base64); // ✅ base64
                      // setState(base64) หรือส่งไป API ได้เลย
                      const formdata = new FormData();
                      formdata.append("image", base64.split(",")[1]);

                      const response = await fetch(
                        "https://api.imgbb.com/1/upload?key=" + process.env.REACT_APP_IMGBB_KEY,
                        {
                          method: "POST",
                          body: formdata,
                        }
                      );

                      const result = await response.json();

                      this.setState({
                        photo: result.data.image.url,
                      });
                      loading(false);
                    };
                    reader.readAsDataURL(file);

                    e.target.value = "";
                    e.target.files = null;
                  }}
                />
                {photo ? (
                  <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                    <img
                      alt="example"
                      src={photo}
                      className="rounded-3"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <span
                      className="wpx-30 hpx-30 rounded-circle bg-danger pointer text-white text-20 position-absolute icon d-flex align-items-center justify-content-center shadow"
                      style={{ right: -12, top: -12 }}
                      onClick={() => {
                        this.setState({ photo: "" });
                      }}
                    >
                      {"\uf00d"}
                    </span>
                  </div>
                ) : (
                  <div className="d-flex">
                    <div
                      className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-48 text-contain border-secondary border-2 border-dash rounded-3 pointer select-image"
                      onClick={() => {
                        document.getElementById("image").click();
                      }}
                    >
                      {"\uf03e"}
                    </div>
                    <small className="text-secondary ps-3">
                      <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 600x600 พิกเซล
                      เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                      <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                      <b>ขนาดไฟล์สูงสุด:</b> 5MB
                    </small>
                  </div>
                )}
              </div>
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ภาค</div>
              <select
                className="form-control"
                placeholder="ภาค.."
                onChange={(e) => {
                  this.setState({ 
                    th_sector: e.target.value,
                    us_sector: e.target.value,
                    jp_sector: e.target.value,
                    cn_sector: e.target.value,
                   });
                }}
                value={th_sector}
              >
                <option value="">--ภาค--</option>
                <option value="ภาคเหนือ">ภาคเหนือ</option>
                <option value="ภาคกลาง">ภาคกลาง</option>
                <option value="ภาคตะวันออกเฉียงเหนือ">
                  ภาคตะวันออกเฉียงเหนือ
                </option>
                <option value="ภาคใต้">ภาคใต้</option>
                <option value="หน่วยงานเอกชน">หน่วยงานเอกชน</option>
                <option value="ลูกค้าต่างประเทศ">ลูกค้าต่างประเทศ</option>
              </select>
            </div>
            {tab === "th" && (<div>
    <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ชื่อลูกค้า (TH){required}</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อลูกค้า.."
                onChange={(e) => {
                  this.setState({ th_name: e.target.value });
                }}
                value={th_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (TH)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ th_address: e.target.value });
                }}
                value={th_address}
              />
            </div>
  </div>)}
            {tab === "us" && (<div>
    <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ชื่อลูกค้า (EN)</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อลูกค้า.."
                onChange={(e) => {
                  this.setState({ us_name: e.target.value });
                }}
                value={us_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (EN)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ us_address: e.target.value });
                }}
                value={us_address}
              />
            </div>
  </div>)}
            {tab === "jp" && (<div>
    <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ชื่อลูกค้า (JP)</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อลูกค้า.."
                onChange={(e) => {
                  this.setState({ jp_name: e.target.value });
                }}
                value={jp_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (JP)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ jp_address: e.target.value });
                }}
                value={jp_address}
              />
            </div>
  </div>)}
            {tab === "cn" && (<div>
    <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ชื่อลูกค้า (CN)</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อลูกค้า.."
                onChange={(e) => {
                  this.setState({ cn_name: e.target.value });
                }}
                value={cn_name}
              />
            </div>
            <div className="d-flex mb-3">
              <div className="wpx-100 mt-2">ข้อความ (CN)</div>
              <textarea
                className="form-control"
                placeholder="ข้อความ.."
                rows={5}
                onChange={(e) => {
                  this.setState({ cn_address: e.target.value });
                }}
                value={cn_address}
              />
            </div>
  </div>)}
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
